import { AuditPage } from '@/features/audit';
import { requireAdministratorAccess } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/audit')({
  component: SettingsAuditRoute,
  beforeLoad: async () => {
    // Espelha o guard da API: `@RequireGroups('insurer.administrator')` no
    // controller de auditoria. É gate por GRUPO, não por permissão — não
    // existe `audit.read` no token.
    const isAdministrator = await requireAdministratorAccess();
    if (!isAdministrator) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function SettingsAuditRoute() {
  return <AuditPage />;
}
